module.exports = __webpack_public_path__ + "img/bluesky3100_31.b7b906dc.jpg";